var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"performer-music-item"},[_c('iframe',{attrs:{"src":'https://open.spotify.com/embed/album/' + _vm.albumUrl,"frameborder":"0","allowtransparency":"true","allow":"encrypted-media"}})])}
var staticRenderFns = []

export { render, staticRenderFns }